import clsx from 'clsx'
import { FC } from 'react'

import { FooterMenuProps } from '@/components/FooterMenu/FooterMenuProps'
import Heading from '@/components/Heading'
import Icon from '@/components/Icon'
import Link from '@/components/Link'

import styles from './FooterMenu.module.scss'

const FooterMenu: FC<FooterMenuProps> = ({
  heading = '',
  items = [],
  className = ''
}) => (
  <nav className={clsx(styles['footer-menu'], className)}>
    <Heading className={styles['footer-menu__heading']} level={3}>
      {heading}
    </Heading>
    <ul className={styles['footer-menu__list']}>
      {items.map(({ id, label, href, external }) => (
        <li key={id} className={styles['footer-menu__item']}>
          <Link
            title={label}
            className={styles['footer-menu__link']}
            href={href}
            {...(external
              ? { target: '_blank', rel: 'noopener noreferrer' }
              : {})}
          >
            {external && (
              <span className={styles['footer-menu__icon']}>
                <Icon name={`social/${id}`} />
              </span>
            )}
            <span className={styles['footer-menu__text']}>{label}</span>
          </Link>
        </li>
      ))}
    </ul>
  </nav>
)
export default FooterMenu
